import { NgModule } from "@angular/core";

import { CodeEditorThemeService } from "./services/code-editor-theme.service";
import { CodeEditorTooltipService } from "./services/code-editor-tooltip.service";
import { CodeEditorKeyboardService } from "./services/code-editor-keyboard.service";
import { CodeEditorHighlightService } from "./services/code-editor-highlight.service";


@NgModule({
    providers: [
        CodeEditorHighlightService,
        CodeEditorKeyboardService,
        CodeEditorTooltipService,
        CodeEditorThemeService,
    ],
})
export class TextEditorsCoreModule {
}